import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'pr-page-body',
    templateUrl: './pr-page-body.component.html',
    styleUrls: ['./pr-page-body.component.scss'],
    standalone: false
})
export class PrPageBodyComponent {
  constructor() {}
}
